import script from "./MultiviewTile.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewTile.vue?vue&type=script&setup=true&lang=js"

import "./MultiviewTile.vue?vue&type=style&index=0&id=938b52ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938b52ac"]])

export default __exports__